import styled from "styled-components";

export const ActivateMinerContainer = styled.div`
  padding-inline: 15px;
`;

export const ActivateCard = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-block: 30px;
`;

export const ActivateButton = styled.button`
  margin-inline-start: auto;
  height: 40px;
  width: fit-content;
`;

export const MachineActivateValueText = styled.div`
  color: ${({ theme }) => theme.colors.link.text};
`;
